export default __webpack_public_path__ + "static/media/Load.dd193598.png";